import React from 'react';
import { kpiIsActive, type QueueQuickFilter, type S3Kpi } from './kpiModel';

interface KpiPillsProps {
  kpis: S3Kpi[];
  current: { status: string; unread: boolean; quick?: QueueQuickFilter; slaBreach?: boolean };
  onPickKpi: (kpi: S3Kpi) => void;
  /** Prefisso delle classi: `s3` (barra del Centro Ticket / Posta) o `s4` (barra rappresentante v4). */
  skin: 's3' | 's4';
  /** Classe del contenitore (`s3-bar__kpis`, `s4-repbar__kpis`). */
  className: string;
}

/**
 * Pillole KPI delle barre titolo (`StickyTitleBar`, `v4/RepTitleBar`): le
 * informative sono `div` statici (nessun tab stop), le cliccabili bottoni con
 * `aria-pressed`; `hot` (FUORI SLA della bacheca v4) aggiunge `--hot`.
 */
const KpiPills: React.FC<KpiPillsProps> = ({ kpis, current, onPickKpi, skin, className }) => (
  <div className={className}>
    {kpis.map((k) => {
      const body = (
        <>
          <span className={`${skin}-kpi__v`}>{k.value}</span>
          <span className={`${skin}-kpi__l`}>{k.label}</span>
        </>
      );
      // Le informative non filtrano: non sono bottoni, quindi non prendono il
      // tab stop e si distinguono anche visivamente (`--static`).
      if (!k.clickable) {
        return (
          <div key={k.key} className={`${skin}-kpi ${skin}-kpi--static`} title={k.hint ?? k.label}>
            {body}
          </div>
        );
      }
      const on = kpiIsActive(k, current);
      return (
        <button
          key={k.key}
          type="button"
          aria-pressed={on}
          onClick={() => onPickKpi(k)}
          title={k.hint ?? `Filtra: ${k.label.toLowerCase()}`}
          className={`${skin}-kpi ${skin}-kpi--btn${on ? ` ${skin}-kpi--on` : ''}${k.hot ? ` ${skin}-kpi--hot` : ''}`}
        >
          {body}
        </button>
      );
    })}
  </div>
);

export default KpiPills;
